import { Injectable } from '@angular/core';
declare let gtag: Function;
@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

constructor() { }

public eventEmitter( 
  eventName: string, 
  eventCity: string,
  eventAin: string = null ){ 
       gtag('event', eventName, { 
               eventCity: eventCity, 
               eventAIN: eventAin
               
             })
  }

  public formEmitter( 
    eventName: string, 
    eventForm: string,
     ){ 
         gtag('event', eventName, { 
                 eventForm: eventForm, 
                 
                 
               })
    }
}

   
